import { markSessionAuthenticated } from "./sessionRefresh";

const SKIP_SESSION_REFRESH_KEY = "ilovemacumba:auth:skipSessionRefresh";

export function markSessionLoggedOut(): void {
  try {
    sessionStorage.setItem(SKIP_SESSION_REFRESH_KEY, "1");
  } catch {
    // Ignore storage access issues during logout.
  }
}

export function markSessionLoggedIn(): void {
  markSessionAuthenticated();
  try {
    sessionStorage.removeItem(SKIP_SESSION_REFRESH_KEY);
  } catch {
    // Ignore storage access issues during login bootstrap.
  }
}

/**
 * A 401 on /profile/me may only mean the 15-minute access token expired, so
 * the session query refreshes every time unless the user logged out in this
 * tab. Loops are bounded by the single-flight refresh and the query retry.
 */
export function shouldAttemptSessionRefresh(): boolean {
  try {
    return sessionStorage.getItem(SKIP_SESSION_REFRESH_KEY) !== "1";
  } catch {
    return true;
  }
}

/** Test helper */
export function resetSessionRefreshState(): void {
  try {
    sessionStorage.removeItem(SKIP_SESSION_REFRESH_KEY);
  } catch {
    // Ignore in test environments without sessionStorage.
  }
}
